import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inclino-v3',
  templateUrl: './inclino-v3.component.html',
  styleUrls: ['./inclino-v3.component.css']
})
export class InclinoV3Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
